module.exports = __webpack_public_path__ + "static/sample-20-0e004fe9c01e1a748a0d5f9660377620.png";